import * as React from 'react';

import Link from 'components/Link';

type Props = {
  label: React.ReactElement;
  url: string;
  method: 'to' | 'href';
};

function LinkCell({ label, url, method }: Props) {
  if (!url || !label) {
    return null;
  }

  const stopProp = (e: React.MouseEvent) => e.stopPropagation();

  if (method === 'href') {
    return (
      <Link href={url} onClick={stopProp}>
        {label}
      </Link>
    );
  }

  return (
    <Link to={url} onClick={stopProp}>
      {label}
    </Link>
  );
}

export function getLinkCellGenerator<T>(
  urlFieldName: keyof T,
  method: 'to' | 'href',
  label: React.ReactElement
) {
  return (data: T) => {
    const url = (data[urlFieldName] as unknown) as string;
    return <LinkCell url={url} method={method} label={label} />;
  };
}
